import { Navigate } from 'react-router-dom';

/**
 * Redirects bare "/" to the correct locale-prefixed home route.
 * Spanish is the default language; English only when explicitly chosen.
 */
const LocaleRedirect = () => {
  const saved = localStorage.getItem('locale');
  if (saved === 'en') {
    return <Navigate to="/en" replace />;
  }
  return <Navigate to="/es" replace />;
};

export default LocaleRedirect;
